// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fo9oZ","tabsBox":"styles_tabsBox__3FGQ2","createButton":"styles_createButton__2NJIP"};